<template>

<div class="card card--large" v-cloak>

  <div class="card__title">
    <p>{{ $_('crm_client_reports_message') }}</p>
  </div>

  <div class="color-danger" v-if="error">
    <p class="parsley-error">{{ error }}</p>
  </div>

  <div v-if="!reports.length">
    <button type="button" class="button button--small button--primary" @click="skip()">{{ $_('save') }}</button>
  </div>

  <div v-if="reports.length">

    <table class="table table--striped table--word-break table--stackable milli push--bottom">
      <thead>
      <tr>
        <th>{{ $_('to') }}</th>
        <th>{{ $_('cc') }}</th>
        <th>{{ $_('bcc') }}</th>
        <th>{{ $_('frequency_d') }}</th>
        <th>{{ $_('start_date') }}</th>
        <th>&nbsp;</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(report, index) in reports" v-bind:key="index">
          <td>{{ report.to }}</td>
          <td>{{ report.cc }}</td>
          <td>{{ report.bcc }}</td>
          <td>{{ report.frequency }}</td>
          <td>{{ report.start_date }}</td>
          <td><button class="button button--small button--danger" title="Remove" @click="removeReport(index)">Remove</button></td>
        </tr>
      </tbody>
    </table>

    <button type="button" class="button button--small button--primary" :disabled="loading" @click="saveReports()">{{ $_('save') }} <i class="fa fa-spin fa-spinner" v-if="loading"></i></button>

  </div>

</div>

</template>

<script>
import 'babel-polyfill'
import querystring from 'querystring'
import CRM from './CRM';

var urlParser = document.createElement('a');
urlParser.href = location.href;

export default {
  mixins: [CRM],
  data () {
    return {
      client: {
        id: parseInt(urlParser.pathname.split('/')[2], 10)
      },
      crmClient: null,
      loading: false,
      reports: [],
      error: null,
    }
  },
  mounted() {
    let self = this;
    this.$http.get("/api/v1/" + this.client.id).then(
      function(response) {
        self.client = response.data.client;
        self.getCrmClient();
      },
      function(error) {
        console.error(error);
        self.error = self.$_('crm_client_could_not_get');
      }
    )
  },
  methods: {
    getCrmClient() {
      let self = this;
      this.CRM_getClient(this.client.crm_client_id).then((response) => {
        if (response && response.data.length) {
          self.crmClient = response.data[0];
          let cc = '';
          let bcc = '';
          if (self.crmClient && self.crmClient.rep && self.crmClient.rep.length && self.crmClient.rep[0].email) {
            if (self.crmClient.rep[0].email) cc = bcc = self.crmClient.rep[0].email;
            if (self.crmClient.rep[0].supervisor && self.crmClient.rep[0].supervisor.length && self.crmClient.rep[0].supervisor[0].email) bcc += ', ' + self.crmClient.rep[0].supervisor[0].email;
          }
          self.reports.push(self.formatReport(self.client.email1, cc, bcc));
        } else {
          self.error = self.$_('crm_client_could_not_get');
        }
      }).catch((error) => {
        console.error(error);
        self.error = self.$_('crm_client_could_not_get');
      });
    },
    formatReport(to, cc = '', bcc = '') {
      return {
        action: 'create',
        client_id: this.client.id,
        to: to,
        cc: cc,
        bcc: bcc,
        frequency: 30,
        start_date: moment().add(1, 'month').startOf("month").format('YYYY-MM-DD'),
        run_now: false
      }
    },
    removeReport(index) {
      this.reports.splice(index, 1)
    },
    asyncForEach: async function(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    saveReports: async function(scope) {
      var self = this;
      self.loading = true;
      await self.asyncForEach(self.reports, async (r) => {
        await self.$http.post('/clients/' + self.client.id + '/settings/reports/ajax', querystring.stringify(r)).then((response) => {
            // console.log('1');
          }).catch((error) => {
            console.error(error);
          })
      });
      console.log('2');
      window.location.replace(window.location.href.replace('/crm', ''));
      self.loading = false;
    },
    skip () {
      window.location.replace(window.location.href.replace('/crm', ''));
    }
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/CrmClientReports.vue